export const pathArrayModel = [
  {
    path: '/basic_form/basic_form',
    component: 'app-basic-form',
    name: '首页',
    active: true,
  },
  {
    path: '/system_configuration/water_categories',
    component: 'app-water-categories',
    name: '水价归属',
    active: false,
  },
  {
    path: '/system_configuration/cost_composition',
    component: 'app-cost-composition',
    name: '费用组成',
    active: false,
  },
  {
    path: '/system_configuration/meter_manufacturers',
    component: 'app-meter-manufacturers',
    name: '水表厂家',
    active: false,
  },
  {
    path: '/system_configuration/meter_model',
    component: 'app-meter-model',
    name: '水表型号',
    active: false,
  },
  {
    path: '/system_configuration/meter_caliber',
    component: 'app-meter-caliber',
    name: '水表口径',
    active: false,
  },
  {
    path: '/system_configuration/meter_range',
    component: 'app-meter-range',
    name: '水表量程',
    active: false,
  },
  {
    path: '/system_configuration/communication_protocol',
    component: 'app-communication-protocol',
    name: '通讯协议',
    active: false,
  },
  {
    path: '/system_configuration/water_adjustment',
    component: 'app-water-adjustment',
    name: '水价调整',
    active: false,
  },
  {
    path: '/system_configuration/user_info',
    component: 'app-user-info',
    name: '用户信息',
    active: false,
  },
  {
    path: '/system_configuration/water_adjustment_logs',
    component: 'app-water-adjustment-logs',
    name: '调价历史',
    active: false,
  },
  {
    path: '/system_configuration/water_station',
    component: 'app-business-site',
    name: '营业站点',
    active: false,
  },
  {
    path: '/system_configuration/word_information',
    component: 'app-word-information',
    name: '词语信息',
    active: false,
  },
  {
    path: '/system_configuration/water_areas',
    component: 'app-water-areas',
    name: '所属小区',
    active: false,
  },
  {
    path: '/system_configuration/wechat_config',
    component: 'app-wechat-configuration',
    name: '微信配置',
    active: false,
  },
  {
    path: '/system_configuration/param_config',
    component: 'app-param-configuration',
    name: '参数配置',
    active: false,
  },
  {
    path: '/system_configuration/meter_read_state',
    component: 'app-meter-read-state',
    name: '抄表状态',
    active: false,
  },
  {
    path: '/system_configuration/bank_info',
    component: 'app-bank-info',
    name: '银行信息',
    active: false,
  },
  {
    path: '/system_configuration/invoice_tax_rate',
    component: 'app-invoice-tax-rate',
    name: '发票税率',
    active: false,
  },

  {
    path: '/system_configuration/preferential_plan',
    component: 'app-preferential-plan',
    name: '优惠方案',
    active: false,
  },
  {
    path: '/system_configuration/package_plan',
    component: 'app-package-plan',
    name: '套餐方案',
    active: false,
  },
  {
    path: '/system_configuration/water_company_account',
    component: 'app-water-company-account',
    name: '水司账户',
    active: false,
  },
  {
    path: '/system_configuration/water_over_plan',
    component: 'app-water-over-plan',
    name: '用水方案',
    active: false,
  },
  {
    path: '/tenant_version/version',
    component: 'app-version',
    name: '版本管理',
    active: false,
  },
  {
    path: '/tenant_version/pda_version',
    component: 'app-pda-version',
    name: '抄表APP',
    active: false,
  },
  {
    path: '/custom_tenant/tenant',
    component: 'app-tenant-management',
    name: '租户管理',
    active: false,
  },
  {
    path: '/system_configuration/permission_manage',
    component: 'app-permission-manage',
    name: '权限管理',
    active: false,
  },
  {
    path: '/system_configuration/menu_manage',
    component: 'app-menu-manage',
    name: '菜单管理',
    active: false,
  },
  {
    path: '/system_configuration/user_manage',
    component: 'app-user-manage',
    name: '用户管理',
    active: false,
  },
  {
    path: '/system_configuration/custom_role',
    component: 'app-custom-role',
    name: '角色配置',
    active: false,
  },
  {
    path: '/system_configuration/print_template',
    component: 'app-print-template',
    name: '打印维护',
    active: false,
  },
  {
    path: '/customer_info/cust_group',
    component: 'app-cust-group',
    name: '客户分组',
    active: false,
  },
  {
    path: '/customer_info/quota_approval',
    component: 'app-quota-approval',
    name: '定额核定',
    active: false,
  },
  {
    path: '/customer_info/quota_share',
    component: 'app-quota-share',
    name: '定额共享',
    active: false,
  },
  {
    path: '/meter_read/meter_book',
    component: 'app-meter-book',
    name: '册本信息',
    active: false,
  },
  {
    path: '/meter_read/meter_bookadjust',
    component: 'app-book-adjustment',
    name: '册本调整',
    active: false,
  },
  {
    path: '/customer_info/customer_info',
    component: 'app-customer-information',
    name: '客户信息',
    active: false,
  },
  {
    path: '/customer_info/area_measure',
    component: 'app-area-measure',
    name: '分区计量',
    active: false,
  },
  {
    path: '/customer_info/customer_detail',
    component: 'app-customer-information-detail',
    name: '客户详情',
    active: false,
  },
  {
    path: '/meter_read/meter_reading',
    component: 'app-meter-reading',
    name: '抄表录入',
    active: false,
  },
  // {
  //   path: '/meter_read/meter_read_import',
  //   component: 'app-meter-reading-import',
  //   name: '抄表数据导入',
  //   active: false,
  // },
  {
    path: '/meter_read/meter_check',
    component: 'app-meter-check',
    name: '复核开账',
    active: false,
  },
  {
    path: '/meter_read/meter_checkinfo',
    component: 'app-meter-checkinfo',
    name: '开账记录',
    active: false,
  },
  {
    path: '/meter_replace_order/meter_replace',
    component: 'app-meter-replaces',
    name: '换表工单',
    active: false,
  },
  {
    path: '/meter_replace_order/business_list',
    component: 'app-business-list',
    name: '业务清单',
    active: false,
  },
  {
    path: '/meter_replace_order/report_list',
    component: 'app-report-list',
    name: '上报清单',
    active: false,
  },
  {
    path: '/meter_replace_order/receivable_payable',
    component: 'app-receivable-payable',
    name: '业财融合',
    active: false,
  },
  {
    path: '/customer_info/Collection_management',
    component: 'app-collection-management',
    name: '集收管理',
    active: false,
  },
  {
    path: '/customer_info/cust_create',
    component: 'app-customer-create',
    name: '立户建档',
    active: false,
  },
  {
    path: '/customer_info/install_acceptance',
    component: 'app-install-acceptance',
    name: '工程验收',
    active: false,
  },
  {
    path: '/search/arrears_search',
    component: 'app-arrears-search',
    name: '欠费查询',
    active: false,
  },
  {
    path: '/operating_fee/red_dashed_record',
    component: 'app-red-dashed-record',
    name: '红冲记录',
    active: false,
  },
  {
    path: '/operating_fee/special_out_a_bill',
    component: 'app-special-out-a-bill',
    name: '特殊开账',
    active: false,
  },
  {
    path: '/operating_fee/at_charges',
    component: 'app-counter-charge',
    name: '柜台收费',
    active: false,
  },
  {
    path: '/operating_fee/counter_checkout',
    component: 'app-counter-checkout',
    name: '柜台结账',
    active: false,
  },
  {
    path: '/search/test',
    component: 'app-test',
    name: '打印测试',
    active: false,
  },
  {
    path: '/system_configuration/common_set',
    component: 'app-common-setting',
    name: '基础设置',
    active: false,
  },
  {
    path: '/invoice_manage/invoice_search',
    component: 'app-invoice-search',
    name: '发票查询',
    active: false,
  },
  {
    path: '/invoice_manage/invoice_create',
    component: 'app-invoice-create',
    name: '发票开具',
    active: false,
  },
  {
    path: '/invoice_manage/invoice_manual_create',
    component: 'app-invoice-manual-create',
    name: '手工开票',
    active: false,
  },
  {
    path: '/collecting_business/realtime_charge',
    component: 'app-realtime-charge',
    name: '实时收费',
    active: false,
  },
  {
    path: '/collecting_business/bank_withholding',
    component: 'app-bank-withholding',
    name: '银行代扣',
    active: false,
  },
  {
    path: '/collecting_business/bank_collection',
    component: 'app-bank-collection',
    name: '银行托收',
    active: false,
  },
  {
    path: '/collecting_business/transfer_write_off',
    component: 'app-transfer-write-off',
    name: '转账核销',
    active: false,
  },
  {
    path: '/search/repord_query',
    component: 'app-repord-query',
    name: '报表查询',
    active: false,
  },
  {
    path: '/search/payment_records',
    component: 'app-payment-records',
    name: '缴费记录',
    active: false,
  },
  {
    path: '/search/business_indicators',
    component: 'app-business-indicators',
    name: '业务指标',
    active: false,
  },
  {
    path: '/reminder/arrearage_reminder',
    component: 'app-arrearage-reminder',
    name: '欠费催缴',
    active: false,
  },
  {
    path: '/reminder/remind_record',
    component: 'app-remind-record',
    name: '催缴记录',
    active: false,
  },
  {
    path: '/reminder/water_cut_record',
    component: 'app-water-cut-record',
    name: '停水复水',
    active: false,
  },
  {
    path: '/we_chat/sales_network',
    component: 'app-sales-network',
    name: '营业网点',
    active: false,
  },
  {
    path: '/we_chat/piblic_terrace',
    component: 'app-public-terrace',
    name: '公众平台',
    active: false,
  },
  {
    path: '/we_chat/parameter_configuration',
    component: 'app-parameter-configuration',
    name: '微信参数',
    active: false,
  },
  {
    path: '/we_chat/page_layout',
    component: 'app-page-layout',
    name: '页面配置',
    active: false,
  },
  {
    path: '/we_chat/inform_management',
    component: 'app-page-inform-management',
    name: '通知管理',
    active: false,
  },
  {
    path: '/we_chat/article_search',
    component: 'app-article-search',
    name: '文章管理',
    active: false,
  },
  {
    path: '/we_chat/new_article',
    component: 'app-new-article',
    name: '添加文章',
    active: false,
  },
  {
    path: '/we_chat/business_type',
    component: 'app-business-type',
    name: '业务类型',
    active: false,
  },
  {
    path: '/we_chat/expand_fields',
    component: 'app-expand-the-fields',
    name: '业务字段',
    active: false,
  },
  {
    path: '/we_chat/business_work_order',
    component: 'app-business-work-order',
    name: '业务工单',
    active: false,
  },
  {
    path: '/we_chat/business_data',
    component: 'app-business-data',
    name: '业务资料',
    active: false,
  },
  {
    path: '/accadjust/nopay',
    component: 'app-nopay',
    name: '未销调整',
    active: false,
  },
  {
    path: '/accadjust/payadjust',
    component: 'app-payadjust',
    name: '已销调整',
    active: false,
  },
  {
    path: '/accadjust/adjustinfo',
    component: 'app-adjustinfo',
    name: '账务日志',
    active: false,
  },
  {
    path: '/accadjust/account_record',
    component: 'app-account-record',
    name: '预存调整',
    active: false,
  },
  {
    path: '/system_configuration/import_data',
    component: 'app-import-data',
    name: '数据导入',
    active: false,
  },
  {
    path: '/system_configuration/system_table_header',
    component: 'app-system-table-header',
    name: '自定义列',
    active: false,
  },
  {
    path: '/system_configuration/log_manage',
    component: 'app-log-manage',
    name: '日志管理',
    active: false,
  },
  {
    path: '/system_configuration/meter_reading_params',
    component: 'app-meter-reading-params',
    name: '抄表参数',
    active: false,
  },
  {
    path: '/system_configuration/audit_logging',
    component: 'app-audit-logging',
    name: '审计日志',
    active: false,
  },
  {
    path: '/message_service/message_type',
    component: 'app-message-setting',
    name: '消息类型',
    active: false,
  },
  {
    path: '/message_service/message_template',
    component: 'app-message-template',
    name: '消息模板',
    active: false,
  },
  // {
  //   path: '/message_service/message_setting',
  //   component: 'app-message-setting',
  //   name: '消息配置',
  //   active: false,
  // },
  {
    path: '/message_service/send_message_record',
    component: 'app-send-message-record',
    name: '消息列表',
    active: false,
  },
  {
    path: '/operating_fee/card_table_management',
    component: 'app-card-table-management',
    name: '卡表管理',
    active: false,
  },
  {
    path: '/operating_fee/batch_charge',
    component: 'app-batch-charge',
    name: '批量缴费',
    active: false,
  },
  {
    path: '/reminder/deposit',
    component: 'app-prestore-money',
    name: '余额提醒',
    active: false,
  },
  {
    path: '/customer_info/customer_alteration',
    component: 'app-customer-alteration',
    name: '批量修改',
    active: false,
  },
  {
    path: '/customer_info/package_processing',
    component: 'app-package-processing',
    name: '套餐办理',
    active: false,
  },
  {
    path: '/engineering_management/engineering_query',
    component: 'app-engineering-query',
    name: '工程查询',
    active: false,
  },
  {
    path: '/engineering_management/engineering_application',
    component: 'app-engineering-application',
    name: '工程申请',
    active: false,
  },
  {
    path: '/engineering_management/engineering_registration',
    component: 'app-engineering-registration',
    name: '工程上户',
    active: false,
  },
  {
    path: '/engineering_management/install_reservation',
    component: 'app-install-reservation',
    name: '报装预约',
    active: false,
  },
  {
    path: '/meter_replace_order/meter_check',
    component: 'app-meter-check',
    name: '稽查工单',
    active: false,
  },
  {
    path: '/tableservice_management/warehousing',
    component: 'app-warehousing',
    name: '零星入库',
    active: false,
  },
  {
    path: '/tableservice_management/meter_purchase',
    component: 'app-meter-purchase',
    name: '水表采购',
    active: false,
  },
  {
    path: '/tableservice_management/meter_purchase_in',
    component: 'app-meter-purchase-in',
    name: '采购入库',
    active: false,
  },
  {
    path: '/tableservice_management/water-meter-verification',
    component: 'app-water-meter-verification',
    name: '水表检定',
    active: false,
  },
  {
    path: '/tableservice_management/water-meter-verification-detail',
    component: 'app-water-meter-verification-detail',
    name: '检定明细',
    active: false,
  },
  {
    path: '/tableservice_management/water-meter-verification-create',
    component: 'app-water-meter-verification-create',
    name: '新增检定',
    active: false,
  },
  {
    path: '/tableservice_management/out_of_stock',
    component: 'app-out-of-stock',
    name: '领用出库',
    active: false,
  },
  {
    path: '/tableservice_management/new_entry_warehouse',
    component: 'app-new-entry-warehouse',
    name: '新建入库',
    active: false,
  },
  {
    path: '/tableservice_management/inventory',
    component: 'app-inventory',
    name: '库存盘点',
    active: false,
  },
  {
    path: '/tableservice_management/new_outbound',
    component: 'app-new-outbound',
    name: '新建出库',
    active: false,
  },
  {
    path: '/tableservice_management/meter_logs',
    component: 'app-meter-logs',
    name: '水表日志',
    active: false,
  },
  {
    path: '/tableservice_management/warehousing_detail',
    component: 'app-warehousing-detail',
    name: '入库明细',
    active: false,
  },
  {
    path: '/tableservice_management/outbound_detail',
    component: 'app-outbound-details',
    name: '出库明细',
    active: false,
  },
  {
    path: '/meter_replace_order/mobile_meter_work',
    component: 'app-mobile-meter-work',
    name: '移表工单',
    active: false,
  },
  {
    path: '/meter_replace_order/repair_work_order',
    component: 'app-repair-work-order',
    name: '维修工单',
    active: false,
  },
  {
    path: '/meter_replace_order/inspection_work_order',
    component: 'app-inspection-work-order',
    name: '验表工单',
    active: false,
  },
  {
    path: '/meter_replace_order/gate_opening_work_order',
    component: 'app-gate-opening-work-order',
    name: '开闸工单',
    active: false,
  },
  {
    path: '/meter_replace_order/meter_remove',
    component: 'app-meter-remove',
    name: '拆表工单',
    active: false,
  },
  {
    path: '/search/reader_track',
    component: 'app-reader-track',
    name: '抄表轨迹',
    active: false,
  },
  {
    path: '/system_configuration/custcode_rule',
    component: 'app-custcode-rule',
    name: '户号规则',
    active: false,
  },
  {
    path: '/sanitation_system/billing_check',
    component: 'app-billing-check',
    name: '计费核定',
    active: false,
  },
  {
    path: '/sanitation_system/billing_refund_appends',
    component: 'app-billing-refund-appends',
    name: '计费退补',
    active: false,
  },
  {
    path: '/sanitation_system/billing_remission',
    component: 'app-billing-remission',
    name: '计费减免',
    active: false,
  },
  {
    path: '/valve_management/device_info',
    component: 'app-device-information',
    name: '设备信息',
    active: false,
  },
  {
    path: '/valve_management/device_info_detail',
    component: 'app-valve-detail',
    name: '设备详情',
    active: false,
  },
  {
    path: '/valve_management/opera_record',
    component: 'app-operation-record',
    name: '操作记录',
    active: false,
  },
  {
    path: '/valve_management/exception_instructions',
    component: 'app-exception-instructions',
    name: '异常指令',
    active: false,
  },
  {
    path: '/system_configuration/sewage_effluent_item',
    component: 'app-sewage-effluent-item',
    name: '因子管理',
    active: false,
  },
  {
    path: '/system_configuration/sewage_effluent_industry',
    component: 'app-sewage-effluent-industry',
    name: '行业分类',
    active: false,
  },
  {
    path: '/system_configuration/sewage_effluent_check',
    component: 'app-sewage-effluent-check',
    name: '核定录入',
    active: false,
  },
  {
    path: '/electronic_signature/template_manage',
    component: 'app-template-management',
    name: '合同模板',
    active: false,
  },
  {
    path: '/electronic_signature/supplier_manage',
    component: 'app-supplier-management',
    name: '平台信息',
    active: false,
  },
  {
    path: '/electronic_signature/contract_signing_record',
    component: 'app-contract-signing-record',
    name: '签订列表',
    active: false,
  },
  {
    path: '/meter_replace_order/financial_shared',
    component: 'app-financial-shared',
    name: '财务共享',
    active: false,
  },
  {
    path: '/meter_read/camera_recognition',
    component: 'app-camera-recognition',
    name: '摄像识别',
    active: false,
  },
  {
    path: '/system_configuration/announcement',
    component: 'app-announcement',
    name: '公告管理',
    active: false,
  },
  {
    path: '/system_configuration/announcement_form',
    component: 'app-announcement-form',
    name: '添加公告',
    active: false,
  },
  {
    path: '/system_configuration/holiday',
    component: 'app-holiday',
    name: '节假日',
    active: false,
  },
];
